// Registers the service worker that makes the app installable (PWA) and enables
// an offline fallback. Registration is best-effort: any failure is logged and
// ignored so it can never break the app.

export function register() {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

      // Whether a service worker was already controlling this page when it
      // loaded. Used to auto-reload ONLY on updates (not the first install).
      const hadController = !!navigator.serviceWorker.controller;
      let refreshing = false;

      // When the new worker takes control, reload once so the user immediately
      // sees the freshly deployed version without a manual hard refresh.
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing || !hadController) return;
        refreshing = true;
        window.location.reload();
      });

      navigator.serviceWorker
        .register(swUrl, { updateViaCache: "none" })
        .then((registration) => {
          // Check for a new deploy now, when the tab regains focus, and hourly,
          // so long-lived tabs also pick up updates.
          const checkForUpdate = () => registration.update().catch(() => {});
          checkForUpdate();
          window.addEventListener("focus", checkForUpdate);
          setInterval(checkForUpdate, 60 * 60 * 1000);

          // When an update is found, ask it to activate as soon as it's ready.
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (!newWorker) return;
            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                newWorker.postMessage({ type: "SKIP_WAITING" });
              }
            });
          });
        })
        .catch((err) => {
          console.warn("Service worker registration failed:", err);
        });
    });
  }
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => {});
  }
}
